import { Injectable, inject } from '@angular/core';

import { GeneralService } from 'app/services/data/general.service';
import { Observable } from 'rxjs';

@Injectable()

export class TelemetryResolver  {
    private generalService = inject(GeneralService);

    resolve(): Observable<boolean> {
        return this.generalService.fetchCommonData$();
    }
}

// export const TelemetryResolver: ResolveFn<boolean> = (
//     _: ActivatedRouteSnapshot,
//     __: RouterStateSnapshot
// ): Observable<boolean> => { return inject(GeneralService).fetchCommonData() };
